module.exports = __webpack_public_path__ + "img/移动航空站.3d58d720.png";